import { render, staticRenderFns } from "./quotationCostLcl.vue?vue&type=template&id=0093de22&scoped=true&"
import script from "./quotationCostLcl.vue?vue&type=script&lang=js&"
export * from "./quotationCostLcl.vue?vue&type=script&lang=js&"
import style0 from "./quotationCostLcl.vue?vue&type=style&index=0&id=0093de22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0093de22",
  null
  
)

export default component.exports